<template>
    <div>
        <b-table
            bordered
            :fields="fields"
            :items="data.data"
            :small="true"
            thead-class="thead-orange"
        >
        <template slot="actions" slot-scope="data">
                <b-button variant="danger" @click="removeMenu(data.item)"><i class="fa fa-trash"></i></b-button>
            </template>
        </b-table>
        <app-paginator 
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        />
    </div>  

    
</template>
<script>
    import Paginator from '../../../UI/Controls/Paginator/Paginator.vue';
    import fields from './fields';
    export default {
        components: {
            appPaginator: Paginator,
        },
        data(){
            return {
                fields: fields
            }
        },
        props: {
            data: {
                required: true
            },
            onChangePage: {
                type: Function,
                required: true
            }
        },
        methods: {
            removeMenu(data){
                this.$emit('remove-menu', data);
            }
        }
    }
</script>